/** 外観調査内観調査 */
export const INSPECTION_METHODS = {
  EXTERNAL: '1',
  INTERNAL: '2'
} as const
